import React from "react";
import { Link } from "react-router-dom";

const AboutOmnia = () => {
  return (
    <section className="py-6 container">
      <div className="row align-items-center" style={{ paddingTop: "2rem" }}>
        <div
          className="col-md-6"
          data-aos="fade-right"
          data-aos-offset="300"
          data-aos-easing="ease-in-sine"
        >
          <div className="blur-shadow-image text-center mx-3 mb-5">
            <img
              src="./images/AboutOmnia/about_omnia1.png"
              alt="img-blur-shadow"
              className="img-fluid  border-radius-lg max-height-600"
            />
          </div>
        </div>
        <div
          className="col-md-6 mb-md-0 mb-4"
          data-aos="fade-left"
          data-aos-offset="300"
          data-aos-easing="ease-in-sine"
        >
          <h2 className="text-gradient bg-primary mb-0">Omnia Steels</h2>
          <br />
          <p
            className=" mb-md-5 mb-4"
            style={{
              fontSize: "1.35rem",
            }}
          >
            Omnia Steels Private Limited (formerly Gupta Steels) is a leading
            business since 40+ years operating across multiple states of India.
            Our ISO & CE certified products are renowned for their superior
            quality and competitive pricing. We provide logistical support to
            supply at any location in India.
          </p>
          <Link to="/about" className="text-primary icon-move-right">
            More about us
            {/* <i className="fas fa-arrow-right text-xs ms-1" aria-hidden="true" />*/}
            <img
              src="./images/arrow-right.svg"
              alt="arrow-right"
              className="ms-2"
              height={14}
              width={14}
            />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AboutOmnia;
